import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TokenPayload, TokenService} from '../../services/token.service';
import {StudentBlock, StudentsModuleStaffTabConst} from '../../constants/modules';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'apps-staff-dropdown',
  templateUrl: './staffDropdown.html',
})
export class StaffDropdownComponent implements OnInit {
  @Output() public loading: boolean = false;
  @Input() selectedOption: string | null;
  @Output() selectedOptionChange: EventEmitter<string | null> = new EventEmitter<string | null>();

  selectOption(option: string) {
    this.selectedOption = option;
    this.selectedOptionChange.emit(this.selectedOption);
  }

  private token: TokenPayload | null;

  public enabledOptions: StudentBlock[];

  constructor(private tokenService: TokenService) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.token = this.tokenService.getUserToken();
    this.evaluateToken();
  }

  private evaluateToken() {
    if(!this.token) {
      return;
    }

    const staffValues = Array.isArray(StudentsModuleStaffTabConst)
      ? StudentsModuleStaffTabConst.map(x => x)
      : Object.values(StudentsModuleStaffTabConst as Record<string, StudentBlock>).map(x => x);

    const enabledModules = this.token.enabledModules || [];
    const newOptions: StudentBlock[] = [];

    for (const staffValue of staffValues) {
      if(enabledModules.indexOf(staffValue.path) > -1 || environment.roleModuleDisabled) {
        newOptions.push(staffValue);
      }
    }

    this.enabledOptions = newOptions;
  }
}
